import { Injectable } from '@angular/core';
import {
  PaymentTypesQuery,
  PaymentTypeType,
} from '@generated/graphql';
import {map, Observable } from 'rxjs';
import { PaymentType } from "@modules/payment/models/payment-type.model";
import { paymentTypeFactory } from "@modules/payment/factories/payment-type.factory";

@Injectable({
  providedIn: 'root',
})
export class PaymentTypeApi {
  constructor (
    private readonly paymentTypesQuery: PaymentTypesQuery,
  ) {
  }

  get$ (): Observable<PaymentType[]> {
    return this.paymentTypesQuery.watch().valueChanges.pipe(
      map(res => res.data.paymentTypes ? res.data.paymentTypes.map(type => paymentTypeFactory.create(type as PaymentTypeType)) : []),
    );
  }
}
